module.exports = __webpack_public_path__ + "resources/icon_50_share.12e608c72c90d175.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_share.png
// module id = 435
// module chunks = 0 1 2 3 4